import { ID_STATUSES } from '../ducks/IDVerification.duck';

export const MEMBERSHIP_TIERS = {
  BASIC: 'basic',
  PREMIUM: 'premium',
  ADMIN: 'admin',
};

export const INSURANCE_STATUSES = {
  ACTIVE: 'active',
  CANCELED: 'canceled',
  DECLINED: 'declined',
  PENDING: 'pending',
};

const INSURANCE_STATUS_ALIASES = {
  active: INSURANCE_STATUSES.ACTIVE,
  canceled: INSURANCE_STATUSES.CANCELED,
  cancelled: INSURANCE_STATUSES.CANCELED,
  declined: INSURANCE_STATUSES.DECLINED,
  pending: INSURANCE_STATUSES.PENDING,
};

// eslint-disable-next-line import/prefer-default-export
export const isVerified = user => {
  return user?.attributes?.profile?.protectedData?.idVerification?.status === ID_STATUSES.VERIFIED;
};

export const getFirstName = displayName => {
  return displayName ? displayName.split(' ')[0] : '';
};

export const isLandowner = user => {
  return user?.attributes?.profile?.protectedData?.role?.includes('landowner');
};

export const hasAdminMembership = user => {
  return user?.attributes?.profile?.metadata?.membershipTier === MEMBERSHIP_TIERS.ADMIN;
};

export const hasPremiumMembership = user => {
  return (
    user?.attributes?.profile?.metadata?.membershipTier === MEMBERSHIP_TIERS.PREMIUM ||
    hasAdminMembership(user)
  );
};

export const getMembershipDetails = user => {
  return user?.attributes?.profile?.metadata?.membershipDetails || null;
};

export const getMembershipBillingInterval = user => {
  const membershipDetails = getMembershipDetails(user);
  const billingInterval = membershipDetails?.billingInterval;

  if (billingInterval === 'month' || billingInterval === 'monthly') {
    return 'monthly';
  }

  if (billingInterval === 'year' || billingInterval === 'annual') {
    return 'annual';
  }

  if (!membershipDetails) {
    return null;
  }

  return 'annual';
};

export const getInsuranceDetails = user => {
  return user?.attributes?.profile?.metadata?.insuranceDetails || null;
};

export const getInsuranceCoverageEndDate = user => {
  const insuranceDetails = getInsuranceDetails(user);

  return insuranceDetails?.subscription?.endDate || insuranceDetails?.coverageEndDate || null;
};

export const getInsuranceStatus = user => {
  const metadataStatus = user?.attributes?.profile?.metadata?.insuranceStatus;
  const normalizedMetadataStatus = metadataStatus ? INSURANCE_STATUS_ALIASES[metadataStatus] : null;

  if (normalizedMetadataStatus) {
    return normalizedMetadataStatus;
  }

  const subscriptionStatus = getInsuranceDetails(user)?.subscription?.status;
  const normalizedSubscriptionStatus = subscriptionStatus
    ? INSURANCE_STATUS_ALIASES[subscriptionStatus]
    : null;

  return normalizedSubscriptionStatus || null;
};

export const hasActiveInsuranceCoverage = user => {
  return getInsuranceStatus(user) === INSURANCE_STATUSES.ACTIVE;
};
